export default __webpack_public_path__ + "static/people-f2b0acc5c9bc45bfd3a55865f3a0ac52.svg";